import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import BaseInput from "../../../shared/components/BaseInput";
import BaseButton from "components/common/BaseButton";
import { useIntl } from "react-intl";
import {
  getIndustrySpecialistFormSchema,
  IndustrySpecialistFormData,
} from "./edit-industry-specialist.schema";

interface Props {
  industrySpecialist: IndustrySpecialistFormData;
  onSubmit: (data: IndustrySpecialistFormData) => void;
  isSubmitting: boolean;
}

const EditIndustrySpecialistForm = ({
  industrySpecialist,
  onSubmit,
  isSubmitting,
}: Props) => {
  const intl = useIntl();
  const industrySpecialistFormSchema = getIndustrySpecialistFormSchema(intl);

  const methods = useForm({
    resolver: zodResolver(industrySpecialistFormSchema),
    defaultValues: industrySpecialist,
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="inputs-container">
        <BaseInput
          name="name"
          label={intl.formatMessage({ id: "usAdmin.name" })}
          type="text"
          containerClassName="usadmin-input-name"
        />
        <BaseInput
          name="email"
          label={intl.formatMessage({ id: "usAdmin.email" })}
          type="text"
          containerClassName="usadmin-input-contactName"
        />
        <BaseButton
          text={intl.formatMessage({ id: "usAdmin.update" })}
          type="submit"
          disabled={isSubmitting}
          className="first-column usadmin-form-submit-button"
          handleSubmit={() => {}}
        />
      </form>
    </FormProvider>
  );
};

export default EditIndustrySpecialistForm;
